import api from '@/api';

export default {
	state: {
		summary: null,
		progress: null
	},
	mutations: {
		SET_SCHOOL_ACADEMIC_LEVELS_SUMMARY (state, summary) {
			state.summary = summary;
		},
		SET_SCHOOL_ACADEMIC_LEVELS_PROGRESS (state, progress) {
			state.progress = progress;
		},
		CLEAR_SCHOOL_ACADEMIC_LEVELS_SUMMARY (state) {
			state.summary = null;
		},
		CLEAR_SCHOOL_ACADEMIC_LEVELS_PROGRESS (state) {
			state.progress = null;
		}
	},
	actions: {
		async setSchoolAcademicLevelsSummary (context, summary) {
			context.commit('SET_SCHOOL_ACADEMIC_LEVELS_SUMMARY', summary);
		},

		async setSchoolAcademicLevelsProgress (context, progress) {
			context.commit('SET_SCHOOL_ACADEMIC_LEVELS_PROGRESS', progress);
		},

		async clearSchoolAcademicLevelsSummary (context) {
			context.commit('CLEAR_SCHOOL_ACADEMIC_LEVELS_SUMMARY');
		},

		async clearSchoolAcademicLevelsProgress (context) {
			context.commit('CLEAR_SCHOOL_ACADEMIC_LEVELS_PROGRESS');
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/academicLevels/index.js